// extracted by mini-css-extract-plugin
export default {"card":"h4-z"};